
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Lager 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 88.54 88.54"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"fill":"none","d":"M0 0h88.54v88.54H0z"}})])]),_c('g',{attrs:{"clip-path":"url(#a)"}},[_c('path',{attrs:{"d":"M.31 49.4a44.25 44.25 0 0073.31 28l2.12-2A44.27 44.27 0 100 44.27c0 1.06.05 2.1.12 3.13z","fill":"#ee7203"}})]),_c('path',{attrs:{"d":"M50 14.43H38.57a2.29 2.29 0 00-2.29 2.28h16A2.28 2.28 0 0050 14.43zM30.58 19v53.61H58V19zm21.68 47.91h-16v-8h16zm0-11.41h-16v-8h16zm0-11.41h-16v-8h16z","fill":"#fff"}})])
          )
        }
      }
    